import React, {useContext, useEffect, useState} from 'react'
import _ from 'lodash'
import dayjs from 'dayjs'
import classNames from 'classnames'
import {Checkbox, message, Modal, Select} from 'antd'
import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import useAsync from 'modules/asyncCache/useAsync'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import usePaginationHelper, {createPagerKey} from 'views/AppLocals/hooks/usePaginationHelper'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {getRouteSearchParams, useRouteSearchParam} from 'envs/_current/history'
import {useHistory} from 'modules/navigation/useRouter'
import {Link} from 'react-router-dom'
import getLinkToDetail from 'helpers/getLinkToDetail'
import EmptyHolder from 'components/EmptyHolder'
import {FormActions} from 'components/form/ModernForm'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import WorkspaceContext from '../WorkspaceContext'
import {FamilyIcon} from 'components/Svgs/FamilyIconSvg'
import {BaptismSacramentSvg} from 'components/Svgs/BaptismSacramentSvg'
import {FirstCommunionSacramentSvg} from 'components/Svgs/FirstCommunionSacramentSvg'
import {ConfirmationSacramentSvg} from 'components/Svgs/ConfirmationSacramentSvg'
import {MatrimonySacramentSvg} from 'components/Svgs/MatrimonySacramentSvg'
import {HolyOrdersSacramentSvg} from 'components/Svgs/HolyOrdersSacramentSvg'
import {AnointingOfTheSickSacramentSvg} from 'components/Svgs/AnointingOfTheSickSacramentSvg'
import {
    IoCheckmarkCircleOutline,
    IoClose,
    IoGridOutline,
    IoHomeOutline,
    IoInformationCircleOutline,
    IoLockClosedOutline,
    IoLockOpenOutline,
    IoPeopleOutline,
    IoPersonOutline,
    IoSearchOutline,
    IoSwapHorizontalOutline,
} from 'react-icons/io5'
import {FaPlus} from 'react-icons/fa6'
import {LoadingOutlined} from '@ant-design/icons'
// Nút "+ Lập sổ mới" dùng LẠI NGUYÊN form Lập Sổ Mới của trang cá nhân (Chồng/Vợ) thay vì tạo 1
// bản riêng cho Workspace - xem comment owner_type/owner_id ở CreateFamilyBookForm (FamilyBooks.js).
import {CreateFamilyBookModal} from '../../AppLocals/FamilyBook/containers/FamilyBooks'
import MemberDetailModal from '../../AppLocals/FamilyBook/components/MemberDetailModal'
import FamilyBookImportExportPage from './FamilyBookImportExportPage'
import FamilyBookOverviewPage from './FamilyBookOverviewPage'
import ParishBookReviewDrawer from './ParishBookReviewDrawer'
import {confirmToggleSacramentsLock} from './sacramentsLockHelpers'
import {computeAge} from '../../AppLocals/FamilyBook/functions/memberDisplay'
import GenderIcon from '../../AppLocals/FamilyBook/components/GenderIcon'
import {GenderTypes} from '../../AppLocals/appFieldTypes'
import {
    familyBook_changeFamilyBookParishLinkStatus_Api,
    familyBook_changeFamilyBookStatus_Api,
    familyBook_getFamilyBooks_Api,
    familyBook_getFamilyBooksByParish_Api,
    familyBook_getFamilyBookStatsByParish_Api,
    familyBookMember_fetchFamilyBookMembers_Api,
    familyBookMember_fetchFamilyBookMembersByCelebrationParish_Api,
    familyBookMember_fetchFamilyBookMembersByParish_Api,
    familyBookMember_getMemberStatsByParish_Api,
} from 'apis/familyBook'

// Trang mới, gọn - KHÔNG port nguyên khối Workspace/CatholicHousehold cũ (form 3 bước kiểu
// FieldsFactory, modal CRUD...). Sổ chủ yếu tạo/sửa qua app thường (QR link), org tạo/nhập hàng loạt
// qua bộ Xuất/Nhập generic (xem FamilyBookImportExportPage.js, thay HẲN Excel import cũ
// importFamilyBookFile - đã bỏ); Workspace quản lý duyệt + tra cứu + view-only theo giáo xứ, RIÊNG nút
// "+ Lập sổ mới" cho org tự khai trực tiếp 1 sổ do CHÍNH org sở hữu (owner_type=organization,
// status=1 - không qua duyệt vì org tự tạo, dùng LẠI CreateFamilyBookModal của trang cá nhân qua
// owner_type/owner_id), khác createMyFamilyBook (sổ cá nhân giáo dân, status=-1 chờ duyệt). Vào sổ
// đã tạo để nhập thêm thành viên/bí tích vẫn qua FamilyBookDetail.js dùng chung (canEditFamilyBook()
// tự cho phép org admin sửa sổ org sở hữu) - is_org_managed ở đó ẩn bớt "Liên kết sổ"/"Thêm Cha Mẹ"
// (org chỉ nhập dữ liệu nội bộ sổ, không thay giáo dân thao tác liên sổ). Điều hướng qua sidebar có
// sẵn của Workspace (?rel=<key>, xem FAMILY_BOOK_SUB_ITEMS trong Workspace.js) - KHÔNG dùng tab nội
// bộ riêng để tránh trùng lặp với menu.

// export - AccessPortalPage.js (danh sách "Tra cứu bí tích" ở đó dùng LẠI đúng 3 bảng này, không
// tự chế danh sách bí tích song song - xem comment ở AccessPortalPage.js).
export const SACRAMENT_REL_MAP = {
    'family-book-sacrament-baptism': 'baptism',
    'family-book-sacrament-first_communion': 'first_communion',
    'family-book-sacrament-confirmation': 'confirmation',
    'family-book-sacrament-matrimony': 'matrimony',
    'family-book-sacrament-holy_orders': 'holy_orders',
    'family-book-sacrament-anointing_of_the_sick': 'anointing_of_the_sick',
}
export const SACRAMENT_LABELS = {
    baptism: 'sacrament_baptism',
    first_communion: 'sacrament_first_communion',
    confirmation: 'sacrament_confirmation',
    matrimony: 'sacrament_matrimony',
    holy_orders: 'sacrament_holy_orders',
    anointing_of_the_sick: 'sacrament_anointing_of_the_sick',
}
// Icon riêng theo từng loại bí tích - khớp bộ icon đã gắn vào FAMILY_BOOK_SUB_ITEMS (Workspace.js).
export const SACRAMENT_ICONS = {
    baptism: BaptismSacramentSvg,
    first_communion: FirstCommunionSacramentSvg,
    confirmation: ConfirmationSacramentSvg,
    matrimony: MatrimonySacramentSvg,
    holy_orders: HolyOrdersSacramentSvg,
    anointing_of_the_sick: AnointingOfTheSickSacramentSvg,
}

// ─── Card sổ (dùng chung: sổ tổ chức sở hữu / sổ toàn giáo xứ view-only) ───────

// onApprove/onReject - dùng chung cho CẢ 2 tab nhưng gọi 2 API khác nhau (OwnedSection: duyệt NỘI
// DUNG sổ org tự sở hữu qua changeFamilyBookStatus; ParishSection: xác nhận/từ chối LIÊN KẾT sổ
// giáo dân tự tạo qua changeFamilyBookParishLinkStatus - xem comment 2 API trong familyBook.js).
// Component này không cần biết đang ở tab nào, chỉ cần item.status===-1 + có truyền callback.
//
// onToggleLock - CHỈ ParishSection truyền (sổ org sở hữu không có khái niệm "khoá bí tích", org đã
// tự chủ toàn bộ nội dung sổ mình rồi). Hiện ở sổ ĐÃ XÁC NHẬN (status===1) - giáo xứ có quyền khoá
// lại/mở lại bất kỳ lúc nào, không chỉ đúng lúc duyệt (xem changeFamilyBookParishLinkStatus() BE).
//
// Nội dung hiển thị (KHÔNG kèm hành vi click) - tách riêng để dùng được cả trong <Link> (OwnedSection,
// điều hướng qua trang cá nhân FamilyBookDetail.js - org sở hữu trọn sổ, dùng luồng CRUD đầy đủ vẫn
// hợp lý) lẫn trong trigger của ParishBookReviewDrawer (ParishSection - xem comment ở đó, KHÔNG dùng
// luồng gia phả cá nhân nữa).
const FamilyBookCardContent = ({item, viewOnly, t}) => {
    const headMember = _.get(item, 'head_member')
    const headSpouseMember = _.get(item, 'head_spouse_member')
    const totalMembers = _.get(item, 'total.members', 0)
    return (
        <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
                {item.source_idcode && (
                    <span className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-family-50 text-family-700 tracking-wider">
                        {item.source_idcode}
                    </span>
                )}
                {item.status === -1 && (
                    <span className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-yellow-50 text-yellow-600">
                        {t('pending')}
                    </span>
                )}
                {/* Chỉ có ý nghĩa ở tab "Toàn giáo xứ" (viewOnly=true, gộp cả sổ giáo dân tự tạo
                    lẫn sổ do chính org sở hữu) - is_owned_by_viewer luôn null ở tab "Giáo xứ trực
                    tiếp quản lý" (mọi dòng ở đó đều đã chắc chắn do org sở hữu, mark lặp lại
                    không có ý nghĩa phân biệt). */}
                {viewOnly && item.is_owned_by_viewer && (
                    <span
                        title={t('family book managed directly hint')}
                        className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-family-50 text-family-700">
                        {t('managed directly')}
                    </span>
                )}
                <span className="text-2xs text-color-400 truncate">{item.parish_name}</span>
            </div>
            <div className="font-bold text-sm text-color-000 truncate">{item.title}</div>
            {(headMember || headSpouseMember) && (
                <span className="text-xs text-color-400">
                    {[headMember?.name, headSpouseMember?.name].filter(Boolean).join(' & ')}
                    {' · '}{totalMembers} {t('members')}
                </span>
            )}
            {/* Khu vực (zone_name) - chỉ có khi giáo xứ đã gán qua ParishBookReviewDrawer, không
                bắt buộc mọi sổ đều có nên chỉ hiện khi thực sự tồn tại. */}
            {item.zone_name && (
                <div className="flex items-center gap-1 mt-0.5">
                    <IoHomeOutline size={11} className="text-color-300 flex-shrink-0"/>
                    <span className="text-2xs text-color-400 truncate">{item.zone_name}</span>
                </div>
            )}
            {/* Người nhập sổ (family_books.user_id -> creator, xem FamilyBookTransformerBasic) - CHỈ
                hiện cho sổ do CHÍNH org nhập (truy trách nhiệm "ai đã nhập sổ này"), KHÔNG hiện cho
                sổ giáo dân tự tạo (creator ở đó chính là chủ hộ, không phải thông tin cần track
                thêm). viewOnly (tab "Toàn giáo xứ", trộn cả 2 loại sổ) dùng is_owned_by_viewer để
                phân biệt; !viewOnly (tab "Giáo xứ trực tiếp quản lý") mọi dòng đã CHẮC CHẮN do org
                sở hữu nên luôn hiện (viewerOwner không truyền ở API đó, is_owned_by_viewer luôn
                null - xem comment FamilyBookTransformerBasic). */}
            {(viewOnly ? item.is_owned_by_viewer : true) && item.creator?.name && (
                <div className="flex items-center gap-1 mt-0.5">
                    <IoPersonOutline size={11} className="text-color-300 flex-shrink-0"/>
                    <span className="text-2xs text-color-400 truncate">{t('entered by')} {item.creator.name}</span>
                </div>
            )}
        </div>
    )
}

// reviewDrawer (owner_type/owner_id, CHỈ ParishSection truyền) - tab "Liên kết đến giáo xứ" đổi
// hẳn từ <Link> điều hướng sang trang cá nhân (FamilyBookDetail.js) qua ParishBookReviewDrawer
// RIÊNG (DrawDialog tại chỗ, phạm vi hẹp - xem comment đầu ParishBookReviewDrawer.js). onReviewChanged
// - refetch list cha khi có sửa trong drawer (status/khoá/thông tin sổ/bí tích không tự cập nhật
// ngược lại item đang render ở list).
const FamilyBookCard = ({item, viewOnly, onApprove, onReject, onToggleLock, reviewDrawer, onReviewChanged, approving, t}) => {
    return (
        <div className="p-3 flex items-center gap-3 background border border-color-50 rounded-xl">
            {reviewDrawer ? (
                <ParishBookReviewDrawer
                    bookId={item.id}
                    owner_type={reviewDrawer.owner_type}
                    owner_id={reviewDrawer.owner_id}
                    onChanged={onReviewChanged}
                    t={t}
                    trigger={
                        <div className="flex-1 min-w-0 cursor-pointer">
                            <FamilyBookCardContent item={item} viewOnly={viewOnly} t={t}/>
                        </div>
                    }
                />
            ) : (
                <Link to={getLinkToDetail(item)} className="flex-1 min-w-0 no-underline">
                    <FamilyBookCardContent item={item} viewOnly={viewOnly} t={t}/>
                </Link>
            )}
            {item.status === -1 && (onApprove || onReject) && (
                <div className="flex items-center gap-1.5 flex-shrink-0">
                    {onReject && (
                        <button
                            type="button"
                            disabled={approving}
                            onClick={() => onReject(item.id)}
                            title={t('reject parish link')}
                            className="p-2 flex flex-center rounded-lg border border-color-100 text-color-400 hover:text-rose-600 hover:border-rose-200 cursor-pointer">
                            <IoClose size={14}/>
                        </button>
                    )}
                    {onApprove && (
                        <button
                            type="button"
                            disabled={approving}
                            onClick={() => onApprove(item.id)}
                            className="px-3 py-1.5 flex items-center gap-1.5 rounded-lg bg-family-600 hover:bg-family-700 text-white text-xs font-semibold cursor-pointer">
                            {approving ? <LoadingOutlined/> : <IoCheckmarkCircleOutline size={14}/>}
                            {t('approve')}
                        </button>
                    )}
                </div>
            )}
            {/* Chỉ icon, không kèm text (đã chốt lại - text lặp lại ý badge "Đang chờ"/tiêu đề, chật
                chỗ trên hàng). title vẫn đủ giải thích rõ khi hover.
                MỞ khoá (đang khoá -> bấm để mở) bắt buộc xác nhận lại - hành động RỦI RO (mở quyền
                sửa bí tích cho chủ sổ, kẻo nhấp nhầm mất luôn ý nghĩa "đã đối chiếu"); KHOÁ lại (đang
                mở -> bấm để khoá) là chiều AN TOÀN nên không cần hỏi lại, xem
                confirmToggleSacramentsLock() dùng chung. */}
            {item.status === 1 && onToggleLock && (
                <button
                    type="button"
                    disabled={approving}
                    onClick={() => confirmToggleSacramentsLock(item, onToggleLock, t)}
                    title={t(item.sacraments_locked ? 'unlock sacraments hint' : 'lock sacraments hint')}
                    className={classNames(
                        'p-2 flex flex-center rounded-lg cursor-pointer flex-shrink-0',
                        item.sacraments_locked ? 'bg-family-50 text-family-700' : 'bg-color-50 text-color-400'
                    )}>
                    {item.sacraments_locked ? <IoLockClosedOutline size={14}/> : <IoLockOpenOutline size={14}/>}
                </button>
            )}
        </div>
    )
}

// ─── Trang "Sổ gia đình công giáo" - gộp toàn giáo xứ (view-only) + sổ tổ chức quản lý ─────────

// Trạng thái Đã duyệt/Đang chờ chuyển vào panel filter (nút phễu cuối thanh search) thay vì 1 hàng
// nút riêng luôn hiện - đúng pattern search-bar+funnel+AdvancedFilter đã dùng ở
// WorkspaceOrganizationAnnouncements.js (Truyền thông > Thông báo). Giữ nguyên style pill màu family
// theme sẵn có (KHÔNG dùng ChipGroup của ModernForm - màu rose cứng, lệch theme "family" của cả
// module này) - chỉ đổi chỗ đặt + nguồn state (từ useState cục bộ sang URL param, đồng bộ cách làm).
// Dùng CHUNG cho cả ParishSection (status = đã xác nhận/chờ xác nhận liên kết) lẫn OwnedSection
// (status = đã duyệt/chờ duyệt nội dung) - cùng khái niệm hiển thị approved/pending trên field
// status, chỉ khác Ý NGHĨA nghiệp vụ theo từng tab (xem comment ở nơi gọi changeFamilyBookParishLinkStatus
// vs changeFamilyBookStatus).
const OwnedSectionFilter = ({value = {}, onChange = NullAsDefault}) => {
    const t = useTranslate()
    const status = value?.status ?? 1
    return (
        <div className="mt-3 flex gap-2">
            <button
                type="button"
                onClick={() => onChange({...value, status: 1})}
                className={classNames('px-3 py-1 rounded-full text-xs font-semibold cursor-pointer', status === 1 ? 'bg-family-600 text-white' : 'bg-family-50 text-family-700')}>
                {t('approved')}
            </button>
            <button
                type="button"
                onClick={() => onChange({...value, status: -1})}
                className={classNames('px-3 py-1 rounded-full text-xs font-semibold cursor-pointer', status === -1 ? 'bg-family-600 text-white' : 'bg-family-50 text-family-700')}>
                {t('pending')}
            </button>
        </div>
    )
}

const parishFilterActions = {
    sortBy: 'family-parish-sort-by',
    keyword: 'family-parish-keyword',
    status: 'family-parish-status',
}

// Modal xác nhận liên kết - KHÁC 1 cú click trực tiếp (như OwnedSection.doApprove) vì cần thu thêm
// lựa chọn khoá bí tích + nhắc rõ căn cứ duyệt (đối chiếu sổ vật lý) trước khi bấm xác nhận, theo
// đúng yêu cầu gốc. Checkbox mặc định TICK (khoá) - khớp default sacraments_locked=true khi lần đầu
// xác nhận ở BE (an toàn hơn nếu quên tick).
const ApproveLinkModal = ({item, onClose, onConfirm, submitting, t}) => {
    const [locked, setLocked] = useState(true)
    return (
        <Modal
            width={420}
            className="custom-modal"
            rootClassName="family-theme"
            open={!!item}
            title={<div className="text-center font-bold text-color-000 uppercase tracking-wide">{t('confirm parish link')}</div>}
            destroyOnHidden
            footer={null}
            onCancel={onClose}>
            {item && (
                <form
                    onSubmit={(e) => {
                        e.preventDefault()
                        onConfirm(item.id, locked)
                    }}
                    className="flex flex-col gap-3 pt-2">
                    <div className="flex items-start gap-1.5 text-xs text-color-400 leading-snug p-2.5 bg-family-50 rounded-lg">
                        <IoInformationCircleOutline size={15} className="mt-0.5 flex-shrink-0"/>
                        <span>{t('confirm parish link basis note')}</span>
                    </div>
                    <span className="font-semibold text-sm text-color-000 truncate">{item.title}</span>
                    <label className="flex items-start gap-2 cursor-pointer">
                        <Checkbox checked={locked} onChange={(e) => setLocked(e.target.checked)} className="mt-0.5"/>
                        <span className="text-sm text-color-000 leading-snug">{t('lock sacraments after confirm')}</span>
                    </label>
                    <FormActions onCancel={onClose} submitText="confirm" isSubmitting={submitting} isValid/>
                </form>
            )}
        </Modal>
    )
}

// Thống kê "Sổ Hộ Gia Đình" - đầu tab "Liên kết đến giáo xứ", cùng phạm vi dữ liệu với list ngay
// dưới (parish_id khớp, status=1). by_zone chỉ liệt kê khu vực ĐÃ CÓ ít nhất 1 sổ (BE group theo dữ
// liệu thật, không liệt kê khu vực rỗng) - dùng LUÔN làm nguồn option cho filter khu vực bên dưới
// (ParishSection fetch 1 lần, truyền `stats` xuống đây THUẦN HIỂN THỊ - không tự fetch riêng, tránh
// gọi trùng 2 lần cùng 1 API).
const FamilyBookStatsCard = ({stats, t}) => {
    if (!stats) return null

    return (
        <div className="p-3 flex flex-col gap-2.5 background border border-color-50 rounded-xl">
            <div className="flex items-center justify-between">
                <span className="font-bold text-sm text-color-000">{t('family book stats title')}</span>
                <span className="px-2 py-0.5 rounded-md text-2xs font-bold bg-family-50 text-family-700">
                    {t('total colon')} {stats.total}
                </span>
            </div>
            <div className="grid grid-cols-2 gap-2">
                <div className="p-2.5 flex flex-col gap-0.5 rounded-lg bg-green-50">
                    <span className="text-2xs font-semibold text-green-700">{t('officially registered')}</span>
                    <span className="font-bold text-lg text-green-700">{stats.officially_registered}</span>
                </div>
                <div className="p-2.5 flex flex-col gap-0.5 rounded-lg bg-yellow-50">
                    <span className="text-2xs font-semibold text-yellow-700">{t('parish managed stat label')}</span>
                    <span className="font-bold text-lg text-yellow-700">{stats.parish_managed}</span>
                </div>
            </div>
            {stats.by_zone?.length > 0 && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-2xs font-bold text-color-400 uppercase tracking-widest">{t('family books by zone')}</span>
                    <div className="grid grid-cols-3 gap-2">
                        {stats.by_zone.map((z) => (
                            <div key={z.zone_group_id} className="p-2 flex flex-col items-center gap-0.5 rounded-lg bg-color-50 text-center">
                                <span className="text-2xs text-color-400 truncate w-full">{z.zone_name}</span>
                                <span className="font-bold text-sm text-color-000">{z.total}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

// `stats` - CHA (FamilyBooksPage) fetch + hiện FamilyBookStatsCard, ĐẨY LÊN TRÊN tab bar (giống hệt
// layout trang Tra cứu Giáo dân) - ParishSection chỉ còn dùng lại stats.by_zone làm option cho filter
// khu vực, không tự fetch riêng nữa (tránh gọi trùng API mỗi lần đổi tab/refresh).
const ParishSection = ({owner_id, owner_type, refreshSignal, stats, onStatsChanged, t}) => {
    const statusParam = useRouteSearchParam(parishFilterActions.status)
    const status = statusParam === '-1' ? -1 : 1
    const [refreshCount, setRefreshCount] = useState(0)
    const [approvingItem, setApprovingItem] = useState(null)
    const [zoneFilter, setZoneFilter] = useState(null)
    const zoneOptions = stats?.by_zone || []

    // Duyệt/từ chối/khoá đổi số liệu thống kê (status, sacraments_locked) - stats giờ fetch ở CHA
    // (FamilyBooksPage), phải báo lên qua onStatsChanged mỗi khi có thay đổi, không chỉ tự refetch
    // list cục bộ (setRefreshCount) như trước.
    const bumpRefresh = () => {
        setRefreshCount((c) => c + 1)
        onStatsChanged && onStatsChanged()
    }

    // 3 action RIÊNG (cùng apiInfo, khác onSuccess) thay vì 1 hook chung rồi suy luận message từ
    // response - status trong response KHÔNG đủ phân biệt "vừa duyệt" với "vừa chỉ đổi khoá trên sổ
    // đã duyệt sẵn" (cả 2 đều trả về status=1). Xem comment đầy đủ ở
    // FamilyBookController::changeFamilyBookParishLinkStatus() (BE) - KHÁC hẳn doApprove ở
    // OwnedSection (đó là duyệt NỘI DUNG sổ org tự sở hữu qua changeFamilyBookStatus), ở đây org
    // không chạm nội dung sổ, chỉ công nhận/từ chối "đúng gia đình này thuộc giáo xứ mình".
    const {handleAsyncAction: doApproveLink, loading: approvingLink} = useAsyncAction({
        apiInfo: familyBook_changeFamilyBookParishLinkStatus_Api,
        onSuccess: () => {
            message.success(t('family book link approved'))
            setApprovingItem(null)
            bumpRefresh()
        },
        onError: () => message.error(t('error occurred')),
    })
    const {handleAsyncAction: doRejectLink, loading: rejectingLink} = useAsyncAction({
        apiInfo: familyBook_changeFamilyBookParishLinkStatus_Api,
        onSuccess: () => {
            message.success(t('family book link rejected'))
            bumpRefresh()
        },
        onError: () => message.error(t('error occurred')),
    })
    const {handleAsyncAction: doToggleLock, loading: togglingLock} = useAsyncAction({
        apiInfo: familyBook_changeFamilyBookParishLinkStatus_Api,
        onSuccess: (result, {response}) => {
            message.success(t(_.get(response, 'data.sacraments_locked') ? 'sacraments locked' : 'sacraments unlocked'))
            bumpRefresh()
        },
        onError: () => message.error(t('error occurred')),
    })
    const settingLinkStatus = approvingLink || rejectingLink || togglingLock

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        AdvancedFilter: OwnedSectionFilter,
        isToggleDefault: true,
        query_params: parishFilterActions,
        withKey: createPagerKey([owner_id, owner_type, 'parish-family-books', status, zoneFilter, refreshCount, refreshSignal]),
        pagerInfo: {
            apiInfo: familyBook_getFamilyBooksByParish_Api,
            query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
            renderItem: (item, i) => (
                <FamilyBookCard
                    key={_.get(item, 'id', i)}
                    item={item}
                    viewOnly
                    onApprove={() => setApprovingItem(item)}
                    onReject={(id) => Modal.confirm({
                        rootClassName: 'family-theme',
                        title: t('reject parish link'),
                        content: t('reject parish link confirm text'),
                        okText: t('reject parish link'),
                        okButtonProps: {danger: true},
                        cancelText: t('cancel'),
                        onOk: () => doRejectLink({status: -2}, {type: owner_type, id: owner_id, family_book_id: id}),
                    })}
                    onToggleLock={(id, nextLocked) => doToggleLock(
                        {sacraments_locked: nextLocked},
                        {type: owner_type, id: owner_id, family_book_id: id}
                    )}
                    reviewDrawer={{owner_type, owner_id}}
                    onReviewChanged={bumpRefresh}
                    approving={settingLinkStatus}
                    t={t}
                />
            ),
            renderWrap: (children) => <div className="flex flex-col gap-2">{children}</div>,
            renderEmpty: () => (
                <div className="flex flex-col items-center justify-center py-8 text-color-400">
                    <IoHomeOutline size={28} className="mb-2 opacity-30"/>
                    <span className="text-sm">{t('no family books found')}</span>
                </div>
            ),
        },
        onInit: ({onFilterChange = NullAsDefault}) => {
            onFilterChange({status, zone_group_id: zoneFilter || undefined})
        },
        filter_params: {status, zone_group_id: zoneFilter || undefined},
        dependencies: [status, zoneFilter, refreshCount, refreshSignal],
    })

    return (
        <div className="flex flex-col gap-3">
            {/* Lọc theo khu vực - option nạp CHUNG từ stats.by_zone (fetch ở FamilyBooksPage, xem
                comment đầu component) - không gọi thêm API list Group riêng. */}
            {zoneOptions.length > 0 && (
                <Select
                    allowClear
                    value={zoneFilter || undefined}
                    onChange={(v) => setZoneFilter(v || null)}
                    placeholder={t('all zones')}
                    className="w-full"
                    options={zoneOptions.map((z) => ({value: z.zone_group_id, label: z.zone_name}))}
                />
            )}
            {pager_widget}
            <ApproveLinkModal
                item={approvingItem}
                onClose={() => setApprovingItem(null)}
                onConfirm={(id, locked) => doApproveLink(
                    {status: 1, sacraments_locked: locked},
                    {type: owner_type, id: owner_id, family_book_id: id}
                )}
                submitting={approvingLink}
                t={t}
            />
        </div>
    )
}

const ownedFilterActions = {
    sortBy: 'family-owned-sort-by',
    keyword: 'family-owned-keyword',
    status: 'family-owned-status',
}

const OwnedSection = ({owner_id, owner_type, refreshSignal, t}) => {
    const statusParam = useRouteSearchParam(ownedFilterActions.status)
    const status = statusParam === '-1' ? -1 : 1
    const [refreshCount, setRefreshCount] = useState(0)

    const {handleAsyncAction: doApprove, loading: approving} = useAsyncAction({
        apiInfo: familyBook_changeFamilyBookStatus_Api,
        onSuccess: () => {
            message.success(t('family book approved'))
            setRefreshCount((c) => c + 1)
        },
        onError: () => message.error(t('error occurred')),
    })

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        AdvancedFilter: OwnedSectionFilter,
        isToggleDefault: true,
        query_params: ownedFilterActions,
        withKey: createPagerKey([owner_id, owner_type, status, refreshCount, refreshSignal]),
        pagerInfo: {
            apiInfo: familyBook_getFamilyBooks_Api,
            query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
            renderItem: (item, i) => (
                <FamilyBookCard
                    key={_.get(item, 'id', i)}
                    item={item}
                    onApprove={(id) => doApprove({status: 1}, {id})}
                    approving={approving}
                    t={t}
                />
            ),
            renderWrap: (children) => <div className="mt-3 flex flex-col gap-2">{children}</div>,
            renderEmpty: () => (
                <div className="flex flex-col items-center justify-center py-8 text-color-400">
                    <IoHomeOutline size={28} className="mb-2 opacity-30"/>
                    <span className="text-sm">{t('no family books found')}</span>
                </div>
            ),
        },
        onInit: ({onFilterChange = NullAsDefault}) => {
            onFilterChange({status})
        },
        filter_params: {status},
        dependencies: [status, refreshCount, refreshSignal],
    })

    return (
        <div className="flex flex-col gap-3">
            {pager_widget}
        </div>
    )
}

// key tab -> key mô tả hiển thị bên dưới, giải thích rõ phạm vi dữ liệu của từng tab (xem
// FamilyBookController::getFamilyBooksByParish / getFamilyBooks ở backend để đối chiếu điều kiện).
const FAMILY_BOOKS_TAB_DESCRIPTIONS = {
    parish: 'family books tab whole parish description',
    owned: 'family books tab managed description',
}

// 3 scope xuyên suốt cả module (list sổ, tra cứu giáo dân) - "parish" = mọi sổ có parish_id trùng
// giáo xứ (bất kể ai sở hữu, chỉ cần đã LIÊN KẾT); "owned" = chỉ sổ do CHÍNH org sở hữu/trực tiếp
// nhập liệu; "celebrated" = CĂN THEO family_book_member_sacraments.parish_id (giáo xứ ĐÃ CỬ HÀNH bí
// tích, giáo dân tự khai khi nhập bí tích) - KHÁC "parish"/"owned" (2 cái đó căn theo family_books,
// không xét bí tích cử hành ở đâu; 1 người có thể Rửa Tội ở giáo xứ A nhưng sổ hiện liên kết/cư trú
// giáo xứ B). "owned" chỉ có ý nghĩa ở cấp SỔ (danh sách sổ) nên KHÔNG dùng cho "celebrated" (bí
// tích là chuyện của TỪNG THÀNH VIÊN, không phải của cả sổ). Tách component tab-bar dùng chung,
// nhận `tabs` (mảng {value,label}) - mỗi trang tự khai đúng tổ hợp scope mình cần, không ép cứng 2
// hay 3 tab như bản trước.
const LOOKUP_SCOPES = {PARISH: 'parish', OWNED: 'owned', CELEBRATED: 'celebrated'}

// overflow-x-auto ở div ngoài + whitespace-nowrap trên từng nút - nhãn dài ("Giáo xứ trực tiếp quản
// lý"...) trên mobile hẹp trước đây bị VỠ CHỮ xuống 2-3 dòng làm cả hàng cao bất thường, giờ chỉ
// cuộn ngang trong chính khối tab thay vì đẩy layout tràn dòng.
const LookupScopeTabBar = ({scope, setScope, tabs, t}) => (
    <div className="overflow-x-auto">
        <div className="p-1 bg-family-50 rounded-xl flex items-center gap-2 w-fit">
            {tabs.map((tab) => (
                <button
                    key={tab.value}
                    type="button"
                    onClick={() => setScope(tab.value)}
                    className={classNames('px-3 py-1.5 rounded-lg text-sm font-semibold whitespace-nowrap cursor-pointer', scope === tab.value ? 'background text-family-700' : 'text-family-700 opacity-60')}>
                    {t(tab.label)}
                </button>
            ))}
        </div>
    </div>
)

const FamilyBooksPage = ({owner_id, owner_type, t}) => {
    const history = useHistory()
    const {isSm} = useContext(LayoutContext)
    const [section, setSection] = useState(LOOKUP_SCOPES.PARISH)
    const [showCreate, setShowCreate] = useState(false)

    // ?action=create - cho phép nơi khác (nút hành động ở header access-portal, xem
    // AccessPortalPage.js) điều hướng thẳng vào đây RỒI tự mở modal lập sổ, cùng pattern
    // Courses.js. Xoá param ngay sau khi dùng - tránh mở lại modal khi back/refresh.
    const actionParam = useRouteSearchParam('action')
    useEffect(() => {
        if (actionParam !== 'create') return
        setShowCreate(true)
        const sp = getRouteSearchParams()
        sp.delete('action')
        history.replace({search: '?' + sp.toString()})
    }, [actionParam])
    // Tăng mỗi lần tạo sổ thành công - đẩy vào withKey/dependencies của CẢ 2 tab (sổ mới do org sở
    // hữu match parish_id nên xuất hiện ở CẢ "Toàn giáo xứ" lẫn "Giáo xứ trực tiếp quản lý", xem
    // is_owned_by_viewer) để tab đang KHÔNG active cũng refetch đúng khi user quay lại xem, không chỉ
    // tab vừa switch sang.
    const [refreshSignal, setRefreshSignal] = useState(0)

    // Thống kê fetch Ở ĐÂY (không phải trong ParishSection nữa) - đẩy LÊN TRÊN tab bar, đúng layout
    // trang Tra cứu Giáo dân (MemberStatsCard cũng đứng trước LookupScopeTabBar ở đó). Đồng thời
    // dùng CHUNG 1 lần fetch cho cả zoneOptions của ParishSection, không gọi trùng API.
    const {response: statsResponse} = useAsync({
        apiInfo: familyBook_getFamilyBookStatsByParish_Api,
        query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
        deps: [owner_id, owner_type, refreshSignal],
    })
    const stats = _.get(statsResponse, 'data')

    return (
        <div className="flex flex-col gap-3">
            <FamilyBookStatsCard stats={stats} t={t}/>
            {/* isSm: mobile không đủ chỗ cho tab (2 nhãn dài) + nút "Lập Sổ Mới" cùng 1 hàng - tách
                nút xuống HÀNG RIÊNG, canh phải (self-end - trục ngang trong flex-col chính là "phải"),
                tab bar tự cuộn ngang qua LookupScopeTabBar (overflow-x-auto) nếu vẫn không vừa, KHÔNG
                để tràn/vỡ dòng như trước. Desktop giữ nguyên 1 hàng ngang như cũ. */}
            <div className={classNames('flex gap-2', isSm ? 'flex-col' : 'items-center justify-between')}>
                <LookupScopeTabBar
                    scope={section}
                    setScope={setSection}
                    tabs={[
                        {value: LOOKUP_SCOPES.PARISH, label: 'whole parish'},
                        {value: LOOKUP_SCOPES.OWNED, label: 'managed by organization'},
                    ]}
                    t={t}
                />
                <button
                    type="button"
                    onClick={() => setShowCreate(true)}
                    className={classNames(
                        'px-3 py-1.5 flex items-center gap-1.5 rounded-lg bg-family-600 hover:bg-family-700 text-white text-xs font-semibold cursor-pointer flex-shrink-0',
                        isSm && 'self-end'
                    )}>
                    <FaPlus size={11}/>
                    {t('create new family book')}
                </button>
            </div>
            <div className="flex items-start gap-1.5 text-xs text-color-400 leading-snug">
                <IoInformationCircleOutline size={15} className="mt-0.5 flex-shrink-0"/>
                <span>{t(FAMILY_BOOKS_TAB_DESCRIPTIONS[section])}</span>
            </div>
            {section === 'parish'
                ? <ParishSection
                    owner_id={owner_id}
                    owner_type={owner_type}
                    refreshSignal={refreshSignal}
                    stats={stats}
                    onStatsChanged={() => setRefreshSignal((c) => c + 1)}
                    t={t}
                />
                : <OwnedSection owner_id={owner_id} owner_type={owner_type} refreshSignal={refreshSignal} t={t}/>
            }
            <CreateFamilyBookModal
                owner_type={owner_type}
                owner_id={owner_id}
                visible={showCreate}
                onClose={() => setShowCreate(false)}
                onSuccess={() => {
                    setShowCreate(false)
                    setSection('owned')
                    setRefreshSignal((c) => c + 1)
                }}
                t={t}
            />
        </div>
    )
}

// ─── Trang tra cứu member (dùng chung layout cho tra cứu theo bí tích lẫn tra cứu giáo dân) ─────

// Dòng kết quả - TÁCH RIÊNG khỏi renderItem trước đây (chỉ nằm trong SacramentLookupPage) để
// ParishionerLookupPage bên dưới dùng lại nguyên, không chép lại JSX. Đủ thông tin theo tham khảo
// mockup: tên thánh + tên, giới tính + tuổi + ngày sinh + khu vực (qua family_book.zone_name, xem
// FamilyBookTransformerTiny), tên sổ, và tag từng bí tích ĐÃ NHẬN (item.sacraments luôn có sẵn -
// FamilyBookMemberTransformer trả unconditional, không cần khai param riêng).
// Factory nhận `t` qua closure (renderItem của pager gọi (item, i), không truyền t) - cùng pattern
// renderMemberLookupEmpty ngay bên dưới, không tự chế cách truyền t khác.
// onItemClick - mở MemberDetailModal xem view-only (tái dùng NGUYÊN component đã dùng ở trang cá
// nhân FamilyBooks.js/FamilyBookDetail.js - đã có sẵn đủ hồ sơ + bí tích + Ơn Gọi Thánh Hiến + thân
// nhân trực hệ + link sổ, không viết lại). optional để renderMemberLookupEmpty/nơi khác lỡ tái dùng
// renderMemberLookupItem mà quên truyền vẫn không vỡ (chỉ mất khả năng click, không lỗi).
const renderMemberLookupItem = (t, onItemClick) => (item, i) => {
    const age = computeAge(item.birth_date, item.death_date)
    const receivedTypes = (item.sacraments || []).map((s) => s.sacrament_type)
    const sourceIdcode = _.get(item, 'family_book.source_idcode')
    // Cùng khái niệm belongs_to_parish của MemberStatsCard (status===1 - đã được giáo xứ xác nhận
    // liên kết/sổ do org lập sẵn), KHÔNG tự chế điều kiện khác.
    const belongsToParish = _.get(item, 'family_book.status') === 1
    return (
        <div
            key={_.get(item, 'id', i)}
            onClick={() => onItemClick && onItemClick(item)}
            className={classNames(
                'p-3 flex items-start gap-3 background border border-color-50 rounded-xl',
                onItemClick && 'cursor-pointer hover:border-family-200 hover:shadow-sm transition-all'
            )}>
            <div style={{width: 36, height: 36}} className="flex flex-center rounded-full bg-family-100 text-family-700 font-bold flex-shrink-0">
                {(item.name || '?').charAt(0).toUpperCase()}
            </div>
            <div className="flex-1 min-w-0 flex flex-col gap-1">
                {(sourceIdcode || belongsToParish) && (
                    <div className="flex items-center gap-1.5 flex-wrap">
                        {sourceIdcode && (
                            <span className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-family-50 text-family-700 tracking-wider">
                                {t('book code colon')} {sourceIdcode}
                            </span>
                        )}
                        {belongsToParish && (
                            <span className="flex items-center gap-0.5 px-1.5 py-0.5 rounded text-2xs font-semibold bg-green-50 text-green-700">
                                <IoCheckmarkCircleOutline size={11}/>
                                {t('belongs to parish stat label')}
                            </span>
                        )}
                    </div>
                )}
                <div className="flex items-center gap-1.5 flex-wrap">
                    {item.patron_saint_name && (
                        <span className="text-2xs text-color-300 italic flex-shrink-0">{item.patron_saint_name}</span>
                    )}
                    <span className="font-semibold text-sm text-color-000 truncate">{item.name}</span>
                    <GenderIcon gender={item.gender} size={12} className="text-color-300 flex-shrink-0"/>
                </div>
                <span className="text-xs text-color-400 truncate">
                    {age != null && `${age} ${t('years old')}`}
                    {item.birth_date && ` (${dayjs(item.birth_date).format('DD/MM/YYYY')})`}
                    {_.get(item, 'family_book.zone_name') && ` · ${item.family_book.zone_name}`}
                    {_.get(item, 'family_book.title') && ` · ${item.family_book.title}`}
                </span>
                {receivedTypes.length > 0 && (
                    <div className="flex items-center gap-1 flex-wrap">
                        {receivedTypes.map((type) => (
                            <span key={type} className="px-1.5 py-0.5 rounded text-2xs font-semibold bg-family-50 text-family-700">
                                {t(SACRAMENT_LABELS[type] || type)}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
const renderMemberLookupEmpty = (t) => () => (
    <div className="flex flex-col items-center justify-center py-8 text-color-400">
        <IoSearchOutline size={28} className="mb-2 opacity-30"/>
        <span className="text-sm">{t('no results found')}</span>
    </div>
)

// ─── Trang tra cứu 1 loại bí tích (mỗi mục sidebar = 1 trang riêng, có search) ─────────────────

// 2 tab CÙNG khái niệm parish/owned như FamilyBooksPage ở trên: "Liên kết đến giáo xứ" (bí tích ghi
// nhận trong BẤT KỲ sổ nào có parish_id trùng, kể cả giáo dân tự nhập ở sổ riêng - đúng scope
// fetchFamilyBookMembersByParish với sacrament_type) vs "Bí tích cử hành tại giáo xứ" (chỉ bí tích
// org TRỰC TIẾP khai trong sổ org sở hữu - fetchFamilyBookMembers, hành vi CŨ giữ nguyên).
//
// Bỏ compact+SearchBox riêng, dùng header mặc định (search + nút phễu) của usePaginationHelper -
// cùng pattern ParishionerLookupPage bên dưới (xem comment ở đó) để có filter giới tính/độ tuổi qua
// MemberFilterPanel dùng lại nguyên, chỉ ẩn phần "sacrament status" (showSacramentFilter=false, đã
// cố định 1 loại bí tích qua sacramentType nên lặp lại filter đó không có ý nghĩa).
const sacramentFilterActions = {
    sortBy: 'sacrament-sort-by',
    keyword: 'sacrament-keyword',
    gender: 'sacrament-gender',
    age_bucket: 'sacrament-age-bucket',
}

const SacramentFilterPanel = (props) => <MemberFilterPanel {...props} showSacramentFilter={false}/>

const SacramentLookupPage = ({sacramentType, owner_id, owner_type, t}) => {
    const [scope, setScope] = useState(LOOKUP_SCOPES.PARISH)
    // Bấm 1 dòng kết quả -> xem view-only qua MemberDetailModal (xem comment renderMemberLookupItem).
    const [detailMemberId, setDetailMemberId] = useState(null)
    const genderParam = useRouteSearchParam(sacramentFilterActions.gender)
    const ageBucketParam = useRouteSearchParam(sacramentFilterActions.age_bucket)
    const apiInfo = scope === LOOKUP_SCOPES.PARISH
        ? familyBookMember_fetchFamilyBookMembersByParish_Api
        : familyBookMember_fetchFamilyBookMembersByCelebrationParish_Api

    const [ageMin, ageMax] = ageBucketParam ? ageBucketParam.split('-').map(Number) : [undefined, undefined]
    const currentFilter = {
        sacrament_type: sacramentType,
        gender: genderParam ? Number(genderParam) : undefined,
        age_bucket: ageBucketParam || undefined,
        age_min: ageMin,
        age_max: ageMax,
    }

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        AdvancedFilter: SacramentFilterPanel,
        isToggleDefault: true,
        query_params: sacramentFilterActions,
        withKey: createPagerKey([owner_id, owner_type, sacramentType, scope, genderParam, ageBucketParam]),
        pagerInfo: {
            apiInfo,
            query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
            renderItem: renderMemberLookupItem(t, (item) => setDetailMemberId(item.id)),
            renderWrap: (children) => <div className="flex flex-col gap-2">{children}</div>,
            renderEmpty: renderMemberLookupEmpty(t),
        },
        onInit: ({onFilterChange}) => onFilterChange(currentFilter),
        filter_params: currentFilter,
        dependencies: [scope, sacramentType, genderParam, ageBucketParam],
    })

    // Không còn h3 tiêu đề riêng ở đây - header chung (WorkspaceFamilyBook root) đã hiện đúng tên +
    // icon bí tích đang xem, tránh lặp lại 2 lần.
    return (
        <div className="flex flex-col gap-3">
            <LookupScopeTabBar
                scope={scope}
                setScope={setScope}
                tabs={[
                    {value: LOOKUP_SCOPES.PARISH, label: 'whole parish'},
                    {value: LOOKUP_SCOPES.CELEBRATED, label: 'sacrament administered at parish'},
                ]}
                t={t}
            />
            {pager_widget}
            {/* viewOnly - khu Tra cứu chỉ để xem nhanh, xem comment forceViewOnly ở MemberDetailModal.js. */}
            <MemberDetailModal key={detailMemberId} memberId={detailMemberId} viewOnly onClose={() => setDetailMemberId(null)}/>
        </div>
    )
}

// Thống kê "Giáo Dân" - đầu trang Tra cứu Giáo dân, PHẠM VI GIÁO XỨ CỐ ĐỊNH (không đổi theo tab
// đang xem bên dưới - thống kê tổng quan nhân khẩu cả giáo xứ, không phải riêng theo từng scope).
// Cùng cấu trúc field với FamilyBookStatsCard ở trên nhưng đơn vị là MEMBER, không phải sổ.
const MemberStatsCard = ({stats, t}) => {
    if (!stats) return null
    return (
        <div className="p-3 flex flex-col gap-2.5 background border border-color-50 rounded-xl">
            <div className="flex items-center justify-between">
                <span className="font-bold text-sm text-color-000">{t('member stats title')}</span>
                <span className="px-2 py-0.5 rounded-md text-2xs font-bold bg-family-50 text-family-700">
                    {t('total colon')} {stats.total}
                </span>
            </div>
            <div className="grid grid-cols-2 gap-2">
                <div className="p-2.5 flex flex-col gap-0.5 rounded-lg bg-green-50">
                    <span className="text-2xs font-semibold text-green-700">{t('belongs to parish stat label')}</span>
                    <span className="font-bold text-lg text-green-700">{stats.belongs_to_parish}</span>
                </div>
                <div className="p-2.5 flex flex-col gap-0.5 rounded-lg bg-yellow-50">
                    <span className="text-2xs font-semibold text-yellow-700">{t('parish managed stat label')}</span>
                    <span className="font-bold text-lg text-yellow-700">{stats.parish_managed}</span>
                </div>
                <div className="p-2.5 flex flex-col gap-0.5 rounded-lg bg-family-50">
                    <span className="text-2xs font-semibold text-family-700">{t('newly added or baptized stat label')}</span>
                    <span className="font-bold text-lg text-family-700">{stats.newly_added_or_baptized}</span>
                </div>
                <div className="p-2.5 flex flex-col gap-0.5 rounded-lg bg-color-50">
                    <span className="text-2xs font-semibold text-color-400">{t('deceased stat label')}</span>
                    <span className="font-bold text-lg text-color-000">{stats.deceased}</span>
                </div>
            </div>
            {stats.by_zone?.length > 0 && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-2xs font-bold text-color-400 uppercase tracking-widest">{t('members by zone')}</span>
                    <div className="grid grid-cols-3 gap-2">
                        {stats.by_zone.map((z) => (
                            <div key={z.zone_group_id} className="p-2 flex flex-col items-center gap-0.5 rounded-lg bg-color-50 text-center">
                                <span className="text-2xs text-color-400 truncate w-full">{z.zone_name}</span>
                                <span className="font-bold text-sm text-color-000">{z.total}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

// 4 mốc tuổi cố định (min-max) - đủ dùng cho phân loại nhân khẩu giáo xứ thường gặp (thiếu nhi/thiếu
// niên/người lớn/cao niên), FE tự quy đổi qua age_min/age_max khi gửi BE, không cần bucket tuỳ biến.
const MEMBER_AGE_BUCKETS = [
    {value: '0-12', labelKey: 'age bucket child'},
    {value: '13-17', labelKey: 'age bucket teen'},
    {value: '18-59', labelKey: 'age bucket adult'},
    {value: '60-150', labelKey: 'age bucket senior'},
]

const GENDER_FILTER_OPTIONS = Object.values(GenderTypes).map((g) => ({label: g.label, value: g.value}))

// Panel chip/pill trong funnel (đúng pattern OwnedSectionFilter đã dùng cho Sổ Gia Đình - KHÔNG
// dùng Select rời rạc nữa). value/onChange do ListFilter (usePaginationHelper nội bộ) bơm vào - LUÔN
// phải gửi lại NGUYÊN `value` cũ + field đổi (onChange THAY THẾ toàn bộ object, không tự merge, cùng
// cách OwnedSectionFilter đang làm). zoneOptions bơm qua `filter_params` (xem ParishionerLookupPage -
// filter_params được ListFilter spread thẳng thành prop cho AdvancedFilter, params đó không chỉ để
// giữ giá trị filter hiện tại nên nhét thêm zoneOptions vào đây được, không phải state filter thật).
const MemberFilterPanel = ({value = {}, onChange = NullAsDefault, zoneOptions = [], showSacramentFilter = true}) => {
    const t = useTranslate()
    const toggle = (key, val) => onChange({...value, [key]: value[key] === val ? undefined : val})
    const toggleAgeBucket = (bucket) => {
        if (value.age_bucket === bucket.value) {
            onChange({...value, age_bucket: undefined, age_min: undefined, age_max: undefined})
        } else {
            const [min, max] = bucket.value.split('-').map(Number)
            onChange({...value, age_bucket: bucket.value, age_min: min, age_max: max})
        }
    }
    const pillClass = (active) => classNames(
        'px-3 py-1 rounded-full text-xs font-semibold cursor-pointer',
        active ? 'bg-family-600 text-white' : 'bg-family-50 text-family-700'
    )

    return (
        <div className="mt-3 flex flex-col gap-3">
            {zoneOptions.length > 0 && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-2xs font-bold text-color-400 uppercase tracking-widest">{t('zone')}</span>
                    <div className="flex flex-wrap gap-2">
                        {zoneOptions.map((z) => (
                            <button key={z.zone_group_id} type="button" onClick={() => toggle('zone_group_id', z.zone_group_id)} className={pillClass(value.zone_group_id === z.zone_group_id)}>
                                {z.zone_name}
                            </button>
                        ))}
                    </div>
                </div>
            )}
            <div className="flex flex-col gap-1.5">
                <span className="text-2xs font-bold text-color-400 uppercase tracking-widest">{t('gender')}</span>
                <div className="flex flex-wrap gap-2">
                    {GENDER_FILTER_OPTIONS.map((g) => (
                        <button key={g.value} type="button" onClick={() => toggle('gender', g.value)} className={pillClass(value.gender === g.value)}>
                            {t(g.label)}
                        </button>
                    ))}
                </div>
            </div>
            <div className="flex flex-col gap-1.5">
                <span className="text-2xs font-bold text-color-400 uppercase tracking-widest">{t('age')}</span>
                <div className="flex flex-wrap gap-2">
                    {MEMBER_AGE_BUCKETS.map((b) => (
                        <button key={b.value} type="button" onClick={() => toggleAgeBucket(b)} className={pillClass(value.age_bucket === b.value)}>
                            {t(b.labelKey)}
                        </button>
                    ))}
                </div>
            </div>
            {showSacramentFilter && (
                <div className="flex flex-col gap-1.5">
                    <span className="text-2xs font-bold text-color-400 uppercase tracking-widest">{t('sacrament status')}</span>
                    <div className="flex flex-wrap gap-2">
                        {Object.keys(SACRAMENT_LABELS).map((type) => (
                            <button key={type} type="button" onClick={() => toggle('sacrament_type', type)} className={pillClass(value.sacrament_type === type)}>
                                {t(SACRAMENT_LABELS[type])}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

// ─── Trang "Tra cứu Giáo dân" - GỘP CHUNG tìm theo tên lẫn tìm theo bí tích vào 1 màn hình duy nhất
// (KHÔNG còn "Tra cứu các bí tích" 6 mục riêng - bí tích giờ là filter chip trong MemberFilterPanel,
// showSacramentFilter mặc định true) + 3 tab scope:
// - "Liên kết đến giáo xứ" (PARISH) - thành viên trong BẤT KỲ sổ nào có parish_id trùng, kể cả sổ
//   giáo dân tự tạo (fetchFamilyBookMembersByParish).
// - "Giáo xứ trực tiếp quản lý" (OWNED) - chỉ thành viên trong sổ org sở hữu (fetchFamilyBookMembers).
// - "Bí tích cử hành tại giáo xứ" (CELEBRATED) - CĂN THEO family_book_member_sacraments.parish_id
//   (giáo xứ ĐÃ CỬ HÀNH bí tích, giáo dân tự khai khi nhập) - KHÁC 2 tab trên (căn theo family_books,
//   không xét sổ hiện thuộc/liên kết giáo xứ nào - fetchFamilyBookMembersByCelebrationParish, xem
//   comment đầy đủ ở BE).
//
// Layout giống hệt ParishSection (Sổ Gia Đình): bỏ compact+SearchBox riêng, dùng header mặc định
// của usePaginationHelper (search + nút phễu mở MemberFilterPanel dạng chip/pill) thay vì Select rời
// rạc. 4 field filter (gender/age_bucket/sacrament_type/zone_group_id) URL-sync qua query_params,
// đọc lại bằng useRouteSearchParam - cùng cách OwnedSection đang đọc `status`, không tự chế state
// song song. age_min/age_max (BE cần) suy từ age_bucket, không tự lưu riêng trên URL.
const parishionerFilterActions = {
    sortBy: 'parishioner-sort-by',
    keyword: 'parishioner-keyword',
    gender: 'parishioner-gender',
    age_bucket: 'parishioner-age-bucket',
    sacrament_type: 'parishioner-sacrament-type',
    zone_group_id: 'parishioner-zone',
}

const ParishionerLookupPage = ({owner_id, owner_type, t}) => {
    const [scope, setScope] = useState(LOOKUP_SCOPES.PARISH)
    // Bấm 1 dòng kết quả -> xem view-only qua MemberDetailModal (xem comment renderMemberLookupItem).
    const [detailMemberId, setDetailMemberId] = useState(null)
    const genderParam = useRouteSearchParam(parishionerFilterActions.gender)
    const ageBucketParam = useRouteSearchParam(parishionerFilterActions.age_bucket)
    const sacramentParam = useRouteSearchParam(parishionerFilterActions.sacrament_type)
    const zoneParam = useRouteSearchParam(parishionerFilterActions.zone_group_id)
    const apiInfo = scope === LOOKUP_SCOPES.PARISH
        ? familyBookMember_fetchFamilyBookMembersByParish_Api
        : scope === LOOKUP_SCOPES.CELEBRATED
            ? familyBookMember_fetchFamilyBookMembersByCelebrationParish_Api
            : familyBookMember_fetchFamilyBookMembers_Api

    const {response: statsResponse} = useAsync({
        apiInfo: familyBookMember_getMemberStatsByParish_Api,
        query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
        deps: [owner_id, owner_type],
    })
    const stats = _.get(statsResponse, 'data')
    const zoneOptions = stats?.by_zone || []

    const [ageMin, ageMax] = ageBucketParam ? ageBucketParam.split('-').map(Number) : [undefined, undefined]
    const currentFilter = {
        zone_group_id: zoneParam || undefined,
        gender: genderParam ? Number(genderParam) : undefined,
        age_bucket: ageBucketParam || undefined,
        age_min: ageMin,
        age_max: ageMax,
        sacrament_type: sacramentParam || undefined,
    }

    const [pager_widget] = usePaginationHelper({
        sortHeader: null,
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        AdvancedFilter: MemberFilterPanel,
        isToggleDefault: true,
        query_params: parishionerFilterActions,
        withKey: createPagerKey([owner_id, owner_type, 'parish-member-lookup', scope, zoneParam, genderParam, ageBucketParam, sacramentParam]),
        pagerInfo: {
            apiInfo,
            query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
            renderItem: renderMemberLookupItem(t, (item) => setDetailMemberId(item.id)),
            renderWrap: (children) => <div className="flex flex-col gap-2">{children}</div>,
            renderEmpty: renderMemberLookupEmpty(t),
        },
        onInit: ({onFilterChange = NullAsDefault}) => onFilterChange(currentFilter),
        filter_params: {...currentFilter, zoneOptions},
        dependencies: [scope, zoneParam, genderParam, ageBucketParam, sacramentParam],
    })

    // Không còn h3 tiêu đề riêng - header chung (WorkspaceFamilyBook root) đã hiện "Tra cứu Giáo dân"
    // + icon đúng ngữ cảnh, tránh lặp lại 2 lần (đúng góp ý thực tế đã gặp).
    return (
        <div className="flex flex-col gap-3">
            <MemberStatsCard stats={stats} t={t}/>
            <LookupScopeTabBar
                scope={scope}
                setScope={setScope}
                tabs={[
                    {value: LOOKUP_SCOPES.PARISH, label: 'whole parish'},
                    {value: LOOKUP_SCOPES.OWNED, label: 'managed by organization'},
                    {value: LOOKUP_SCOPES.CELEBRATED, label: 'sacrament administered at parish'},
                ]}
                t={t}
            />
            {pager_widget}
            {/* viewOnly - khu Tra cứu chỉ để xem nhanh, xem comment forceViewOnly ở MemberDetailModal.js. */}
            <MemberDetailModal key={detailMemberId} memberId={detailMemberId} viewOnly onClose={() => setDetailMemberId(null)}/>
        </div>
    )
}

// ─── Root ───────────────────────────────────────────────────────────────────

const WorkspaceFamilyBook = () => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext)
    const owner_id = getId(organization)
    const owner_type = getType(organization)
    const isParishLinked = getType(organization?.association) === 'parish' && Number(organization?.association_status) === 1
    // Mặc định vào "Tổng Quan" (mục đầu tiên trong menu, xem FAMILY_BOOK_SUB_ITEMS) - TRƯỚC ĐÂY mặc
    // định "family-books", đổi theo đúng thứ tự thông tin mới (bức tranh chung trước, thao tác
    // nghiệp vụ sau).
    const rel = useRouteSearchParam('rel') || 'family-book-overview'
    const sacramentType = SACRAMENT_REL_MAP[rel]
    const isOverview = rel === 'family-book-overview'
    const isParishionerLookup = rel === 'family-book-member-lookup'
    const isBulkImportExport = rel === 'family-book-bulk-import-export'

    if (!isParishLinked) {
        return (
            <div className="family-theme px-3 md:px-6">
                <EmptyHolder
                    title="Content is not available"
                    subTitle="The content will be available once the organization has completed linking with a parish"
                />
            </div>
        )
    }

    // Tiêu đề đầu trang đổi theo đúng mục sidebar đang xem - TRƯỚC ĐÂY luôn cố định "Gia Phả & Sổ
    // Gia Đình" dù đang ở trang khác hẳn (Tra cứu Giáo dân/Tra cứu bí tích), khiến header lặp lại 2
    // lần (header chung + h3 riêng của từng trang con) - bỏ hẳn h3 riêng ở SacramentLookupPage/
    // ParishionerLookupPage, để ĐÚNG 1 header duy nhất ở đây.
    const RootIcon = isOverview ? IoGridOutline
        : sacramentType ? (SACRAMENT_ICONS[sacramentType] || FamilyIcon)
            : isParishionerLookup ? IoPeopleOutline
                : isBulkImportExport ? IoSwapHorizontalOutline
                    : FamilyIcon
    const rootTitleKey = isOverview ? 'overview'
        : sacramentType ? SACRAMENT_LABELS[sacramentType]
            : isParishionerLookup ? 'lookup parishioners'
                : isBulkImportExport ? 'bulk import export title'
                    : 'family record books'

    return (
        <div className="family-theme px-3 md:px-6 flex flex-col gap-4">
            <div className="flex items-center gap-2">
                <RootIcon size={22} className="text-family-700"/>
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">{t(rootTitleKey)}</h2>
            </div>

            {isOverview
                ? <FamilyBookOverviewPage/>
                : sacramentType
                    ? <SacramentLookupPage sacramentType={sacramentType} owner_id={owner_id} owner_type={owner_type} t={t}/>
                    : isParishionerLookup
                        ? <ParishionerLookupPage owner_id={owner_id} owner_type={owner_type} t={t}/>
                        : isBulkImportExport
                            ? <FamilyBookImportExportPage owner_id={owner_id} owner_type={owner_type} t={t}/>
                            : <FamilyBooksPage owner_id={owner_id} owner_type={owner_type} t={t}/>
            }

            <div className="h-16"/>
        </div>
    )
}

export default WorkspaceFamilyBook
